


export const getItemByValueId = (array, id) => {

  const search =  array.find( item => item.value == id );
  if(!search) return null;

  return search;
}


export const getItemByText = (array, text) => {
  const search =  array.find( item => item.text === text );

  if(!search) return null;

  return search;
}


export const getItemByTextUpperCase = (array, text) => {
  const search =  array.find( item => item.text.toUpperCase() === text.toUpperCase() );

  if(!search) return null;

  return search;
}